import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  getIosPaymentSafeRoute,
  isIosBlockedPaymentPath,
  shouldHideSubscriptionPurchase,
} from "../utils/platform";

/**
 * Catches deep links / manual URL entry to payment routes on iOS before any page renders.
 */
export default function IosPaymentRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!shouldHideSubscriptionPurchase()) return;
    if (!isIosBlockedPaymentPath(location.pathname)) return;

    const target =
      !loading && isAuthenticated() && user
        ? getIosPaymentSafeRoute(user)
        : "/home";

    navigate(target, { replace: true });
  }, [location.pathname, navigate, user, loading]);

  return null;
}
